import './TwoOptionsQuestion.css';
import Switch from "react-switch";
import React from 'react';

class TwoOptionsQuestion extends React.Component {
  
  render() {
    const {title, trueLabel, falseLabel, value, name} = this.props;
    return (
        <div className="row two-options-question-container">
            <div className="col-md-12">
              <label className="two-options-question-label">{title}</label>
            </div>
            <div className="col-xs-1 hidden-md"></div>
            <div className="col-md-3 col-xs-3 text-center">
              <span className="two-options-question-label">{trueLabel}</span>
            </div>
            <div className="col-md-3 col-xs-3 text-center">
              <Switch
                onChange={
                  (checked)=> {
                    this.props.handleChange(checked, name);
                  }
                }
                className="react-switch"
                checked={value} 
                onColor="#ABD1F9"
                offColor="#FCE0F5"
                uncheckedIcon={false}
                checkedIcon={false}
              />
            </div>
            <div className="col-md-3 col-xs-3 text-center">
                <span className="two-options-question-label">{falseLabel}</span>
            </div>
          </div>
    );
  }
}

export default TwoOptionsQuestion;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/TwoOptionsQuestion/TwoOptionsQuestion.js